import moment from "moment-timezone";
import {DATE_ONLY_FORMAT} from "../config/DateTimeConstants";

export const countPerformers = (shiftPlans) => {
    if (!Array.isArray(shiftPlans)) {
        return {
            scheduled: 0,
            total: 0
        };
    }

    const uniqueScheduledUserIds = new Set();
    const uniqueAllUserIds = new Set();

    shiftPlans.forEach(shiftPlan => {
        if (shiftPlan.enrollments && Array.isArray(shiftPlan.enrollments)) {
            shiftPlan.enrollments.forEach(enrollment => {
                uniqueAllUserIds.add(enrollment.user.id);
                
                if (enrollment.availability !== null) {
                    uniqueScheduledUserIds.add(enrollment.user.id);
                }
            });
        }
    });

    return {
        scheduled: uniqueScheduledUserIds.size,
        total: uniqueAllUserIds.size
    };
};

export const getBookingStatsForDate = (bookingStats, date, timezone) => {

    if (!Array.isArray(bookingStats)){
        return null;
    }
    const targetDate = moment(date).tz(timezone).format(DATE_ONLY_FORMAT);

    return bookingStats.find(stat => {
        const statDate = moment(stat.statDate).tz(timezone).format(DATE_ONLY_FORMAT);
        return statDate === targetDate;
    });
};

export const getSessionCounts = (bookingStats, date, timezone) => {
    const bookingStat = getBookingStatsForDate(bookingStats, date, timezone);
    
    if (!bookingStat) {
        return {
            booked: 0,
            total: 0
        };
    }
    
    return {
        booked: bookingStat.bookedSeats || 0,
        total: (bookingStat.bookedSeats || 0) + (bookingStat.availableSeats || 0)
    };
};